import { httpFetch } from '../../Utils/httpUtils';
import { usageActionTypes as actionTypes } from '../../ActionTypes/Voss/usageActionTypes';
import { commonActionTypes } from '../../ActionTypes/commonActionTypes';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyDispatch = any;

const usageActions = {
    getCustomerUsage: (customerId: string) => {
        return (dispatch: AnyDispatch) => {
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: 'customerUsage', value: true });
            return httpFetch(`/api/usages/${customerId}`, dispatch)
                .then((json: unknown) => {
                    dispatch({ type: actionTypes.STORE_CUSTOMER_USAGE, data: json });
                })
                .finally(() => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: 'customerUsage', value: false });
                });
        };
    },

    clearCustomerUsage: () => ({ type: actionTypes.CLEAR_CUSTOMER_USAGE }),
};

export default usageActions;
